/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationOut } from '../models/NotificationOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationsService {
    /**
     * List Notifications
     * @returns NotificationOut Successful Response
     * @throws ApiError
     */
    public static listNotificationsNotificationsGet(): CancelablePromise<Array<NotificationOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications',
        });
    }
    /**
     * Mark All Read
     * @returns void
     * @throws ApiError
     */
    public static markAllReadNotificationsReadAllPost(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notifications/read-all',
        });
    }
    /**
     * Mark Read
     * @returns NotificationOut Successful Response
     * @throws ApiError
     */
    public static markReadNotificationsIdReadPost({
        id,
    }: {
        id: string,
    }): CancelablePromise<NotificationOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notifications/{id}/read',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
